var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useState, useEffect } from "react";
/** A hook to indicate if hydration has taken place
 *
 * Based on the hook in: https://blog.logrocket.com/fixing-gatsbys-rehydration-issue/
 */
export var useReady = function () {
  var _a = __read(useState(false), 2),
    isReady = _a[0],
    setReady = _a[1];
  var key = isReady ? "client" : "server";
  useEffect(function () {
    setReady(true);
  }, []);
  return {
    isReady: isReady,
    key: key
  };
};